import {products, promotedByPersonalizationProducts} from "../store"
import {Recommendation} from "../../services/recommendation";
import type {WidgetProps} from "../../@types/recommendation";


export default function setProducts(props: WidgetProps, id: string, dev = false) {
    if (dev) {
         Recommendation.getDev(props)
        .then(res => {
            products.update(products => {
                return {
                    ...products,
                    [id]: res.widget_responses[0].products.slice(0, props.specs.maxSuggestions) // slice if server returns more than max suggest items
                }
            })
        })
        .catch(err => console.log(err))
    } else {
        Recommendation.get(props)
            .then(res => {
                promotedByPersonalizationProducts.set(res.widget_responses[0]?.promoted_by_personalization ?? []);
                products.update(products => {
                    return {
                        ...products,
                        [id]: res.widget_responses[0].products.slice(0, props.specs.maxSuggestions) // slice if server returns more than max suggest items
                    }
                })
            })
            .catch(err => console.log(err))
    }
}